"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookingForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _reactRedux = require("react-redux");
var _formik = require("formik");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _yup = require("yup");
var _Input = _interopRequireDefault(require("../../../../../ui/Input"));
var _Textarea = _interopRequireDefault(require("../../../../../ui/Textarea"));
var _Select = _interopRequireDefault(require("../../../../../ui/Select"));
var _Checkbox = _interopRequireDefault(require("../../../../../ui/Checkbox"));
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _config = require("../../../../../../services/config");
var _fn = require("../../../../../../helpers/fn");
var _selectors = require("../../store/selectors");
var _BookingServices = require("../BookingServices");
var _BookingInfoOfReservation = require("../BookingInfoOfReservation");
var _LabelControl = _interopRequireDefault(require("./components/LabelControl"));
var _OperatorOptions = _interopRequireDefault(require("./components/OperatorOptions"));
var _PassportFilesControl = require("./components/PassportFilesControl");
var _BirthdayControl = _interopRequireDefault(require("./components/BirthdayControl"));
var _PreviousBookingsControl = require("./components/PreviousBookingsControl");
var _PaymentTypeControl = require("./components/PaymentTypeControl");
var _SexControl = require("./components/SexControl");
var _selectors2 = require("./store/selectors");
var _constants = require("./constants");
var _helpers = require("./helpers");
var _withProps = _interopRequireDefault(require("./withProps"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var mapIndexed = R.addIndex(R.map);
var PASSPORT_VALIDATE_MIN_LENGTH = 8;
var BookingFormByOperator = function BookingFormByOperator(_ref) {
  var values = _ref.values,
    submitForm = _ref.submitForm,
    offer = _ref.offer,
    disabledPassportFields = _ref.disabledPassportFields,
    externalPassportFields = _ref.externalPassportFields;
  var _useTranslation = (0, _reactI18next.useTranslation)('BOOKING_FORM_BY_OPERATOR'),
    t = _useTranslation.t;
  var countries = (0, _reactRedux.useSelector)(_selectors.getCountries);
  var _useSelector = (0, _reactRedux.useSelector)(_selectors2.getBookingOfferByOperatorUI),
    loading = _useSelector.loading;
  var bookingProcessUI = (0, _reactRedux.useSelector)(_selectors2.getBookingProcessUI);
  var _useSelector2 = (0, _reactRedux.useSelector)(_selectors.getBookingOperator),
    conditionsLink = _useSelector2.conditionsLink,
    operatorName = _useSelector2.name;
  var shouldRecalculatePrice = (0, _reactRedux.useSelector)(_BookingServices.getShouldRecalculatePrice);
  var bookingCompanies = (0, _reactRedux.useSelector)(_selectors.getBookingCompanies);
  var countryList = (0, _react.useMemo)(function () {
    return R.map(function (_ref2) {
      var id = _ref2.id,
        name = _ref2.name;
      return {
        value: id,
        content: name
      };
    }, countries);
  }, [countries]);
  var externalPassportFieldsAsArray = (0, _react.useMemo)(function () {
    return R.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        options = _ref4[1];
      return _objectSpread({
        name: key
      }, options);
    }, R.toPairs(externalPassportFields));
  }, [externalPassportFields]);
  var disabledBookingConditionControl = (0, _config.isDisabledBookingConditionControl)();
  var disabledBookingOperatorControl = (0, _config.isDisabledBookingOperatorControl)();
  var disabledBookingPhoneControl = (0, _config.isDisabledBookingPhoneControl)();
  var disabledBookingPayerEmailControl = (0, _config.isDisabledBookingPayerEmailControl)();
  var onRecognizePassport = (0, _config.getOnRecognizePassport)();
  var onGetPreviousBookings = (0, _config.getOnGetPreviousBookings)();
  var isDisabledSubmitButton = loading || shouldRecalculatePrice || bookingProcessUI.loading;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.claimTitle
  }, t('TITLE')), mapIndexed(function (_, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.title
    }, t('SUB_TITLE', {
      touristCount: index + 1
    })), onRecognizePassport && /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.passWrapper
    }, /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      name: "passports.".concat(index),
      render: function render(_ref5) {
        var field = _ref5.field,
          form = _ref5.form;
        var onPassportLoaded = function onPassportLoaded(recognizedPassport) {
          var enabledFields = R.keys(form.values.passports[index]);
          form.setFieldValue(field.name, R.pick(enabledFields, recognizedPassport));
          form.setFieldTouched(field.name, (0, _helpers.createPassportTouchedEntity)(enabledFields));
        };
        var onError = function onError(_ref6) {
          var message = _ref6.message;
          form.setFieldError("".concat(field.name, ".files"), message);
        };
        var error = (0, _formik.getIn)(form, "errors.".concat(field.name, ".files"));
        return /*#__PURE__*/_react.default.createElement(_PassportFilesControl.PassportFilesControl, {
          onPassportLoaded: onPassportLoaded,
          onError: onError,
          error: error
        });
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.group
    }, /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      name: "passports.".concat(index, ".sex"),
      render: function render(_ref7) {
        var field = _ref7.field,
          form = _ref7.form;
        var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
        return /*#__PURE__*/_react.default.createElement(_SexControl.SexControl, {
          errorMsg: errorMsg,
          value: field.value,
          onChange: function onChange(sex) {
            form.setFieldValue(field.name, sex);
          },
          onBlur: function onBlur() {
            return form.setFieldTouched(field.name, true);
          }
        });
      }
    }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      name: "passports.".concat(index, ".name"),
      render: function render(_ref8) {
        var field = _ref8.field,
          form = _ref8.form;
        var label = t('NAME_CONTROL_LABEL');
        var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
        return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
          className: (0, _classnames.default)(_styles.default.name, _styles.default.label),
          id: field.name,
          label: label
        }, /*#__PURE__*/_react.default.createElement(_Input.default, {
          className: _styles.default.select,
          errorMsg: errorMsg,
          hasError: Boolean(errorMsg),
          id: field.name,
          placeholder: label,
          value: field.value,
          onBlur: function onBlur() {
            return form.setFieldTouched(field.name, true);
          },
          onChange: function onChange(value) {
            var processValue = value.replace(/^\s+/, '');
            form.setFieldValue(field.name, processValue.toUpperCase());
          }
        }));
      }
    }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      name: "passports.".concat(index, ".surname"),
      render: function render(_ref9) {
        var field = _ref9.field,
          form = _ref9.form;
        var label = t('LAST_NAME_CONTROL_LABEL');
        var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
        return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
          className: (0, _classnames.default)(_styles.default.surname, _styles.default.label),
          id: field.name,
          label: label
        }, /*#__PURE__*/_react.default.createElement(_Input.default, {
          className: _styles.default.select,
          errorMsg: errorMsg,
          hasError: Boolean(errorMsg),
          id: field.name,
          placeholder: label,
          value: field.value,
          onBlur: function onBlur() {
            return form.setFieldTouched(field.name, true);
          },
          onChange: function onChange(value) {
            var processValue = value.replace(/^\s+/, '');
            form.setFieldValue(field.name, processValue.toUpperCase());
          }
        }));
      }
    }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      name: "passports.".concat(index, ".birthday"),
      render: function render(_ref10) {
        var field = _ref10.field,
          form = _ref10.form;
        var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
        var childrenIndex = index - offer.people.adults;
        return /*#__PURE__*/_react.default.createElement(_BirthdayControl.default, {
          childrenAge: offer.people.children[childrenIndex],
          errorMsg: errorMsg,
          id: field.name,
          value: field.value,
          onBlur: field.onBlur,
          onChange: function onChange(value) {
            form.setFieldValue(field.name, value);
          }
        });
      }
    }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      name: "passports.".concat(index, ".citizenship"),
      render: function render(_ref11) {
        var field = _ref11.field,
          form = _ref11.form;
        var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
        return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
          className: (0, _classnames.default)(_styles.default.citizenship, _styles.default.label),
          label: t('CITIZENSHIP_CONTROL_LABEL')
        }, /*#__PURE__*/_react.default.createElement(_Select.default, {
          className: _styles.default.select,
          hasError: Boolean(errorMsg),
          items: countryList,
          value: field.value,
          onChange: function onChange(value) {
            form.setFieldValue(field.name, value);
          }
        }));
      }
    }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      name: "passports.".concat(index, ".passport"),
      render: function render(_ref12) {
        var field = _ref12.field,
          form = _ref12.form;
        var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
        return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
          className: (0, _classnames.default)(_styles.default.passport, _styles.default.label),
          id: field.name,
          label: t('PASSPORT_CONTROL_LABEL')
        }, /*#__PURE__*/_react.default.createElement(_Input.default, {
          className: _styles.default.select,
          errorMsg: errorMsg,
          hasError: Boolean(errorMsg),
          id: field.name,
          items: countryList,
          placeholder: "\u0410\u0410728282",
          value: field.value,
          onBlur: function onBlur() {
            return form.setFieldTouched(field.name, true);
          },
          onChange: function onChange(value) {
            form.setFieldValue(field.name, value);
          }
        }));
      }
    }), !disabledPassportFields.passportGivenDate && /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      name: "passports.".concat(index, ".passportGivenDate"),
      render: function render(_ref13) {
        var field = _ref13.field,
          form = _ref13.form;
        var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
        return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
          className: (0, _classnames.default)(_styles.default.given, _styles.default.label),
          id: field.name,
          label: t('GIVEN_DATE_CONTROL_LABEL')
        }, /*#__PURE__*/_react.default.createElement(_Input.default, {
          className: _styles.default.select,
          errorMsg: errorMsg,
          hasError: Boolean(errorMsg),
          id: field.name,
          mask: _constants.PHONE_MASK,
          placeholder: t('BOOKING_FORM_DATE_MASK'),
          value: field.value,
          onBlur: function onBlur() {
            return form.setFieldTouched(field.name, true);
          },
          onChange: function onChange(value) {
            form.setFieldValue(field.name, value);
          }
        }));
      }
    }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      name: "passports.".concat(index, ".passportExpireDate"),
      render: function render(_ref14) {
        var field = _ref14.field,
          form = _ref14.form;
        var isTouched = (0, _formik.getIn)(form, "touched.".concat(field.name));
        var errorMsg = isTouched && (0, _formik.getIn)(form, "errors.".concat(field.name));
        var localErrorMsg = isTouched && !(0, _helpers.getIsPassportExpireDateValidator)({
          expireDate: field.value,
          startTourDate: offer.date,
          months: 6,
          nights: offer.nights
        }) ? t('VALIDITY_CONTROL_LOCAL_ERROR') : undefined;
        return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
          className: (0, _classnames.default)(_styles.default.given, _styles.default.label),
          id: field.name,
          label: t('VALIDITY_CONTROL_LABEL')
        }, /*#__PURE__*/_react.default.createElement(_Input.default, {
          className: _styles.default.select,
          errorMsg: errorMsg,
          warningMsg: localErrorMsg,
          hasError: Boolean(errorMsg),
          id: field.name,
          mask: _constants.PHONE_MASK,
          placeholder: t('BOOKING_FORM_DATE_MASK'),
          value: field.value,
          onBlur: function onBlur() {
            return form.setFieldTouched(field.name, true);
          },
          onChange: function onChange(value) {
            form.setFieldValue(field.name, value);
          }
        }));
      }
    }), !disabledPassportFields.passportIssued && /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      name: "passports.".concat(index, ".passportIssued"),
      render: function render(_ref15) {
        var field = _ref15.field,
          form = _ref15.form;
        var label = t('ISSUED_BY_CONTROL_LABEL');
        var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
        return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
          className: (0, _classnames.default)(_styles.default.passportIssued, _styles.default.label),
          id: field.name,
          label: label
        }, /*#__PURE__*/_react.default.createElement(_Input.default, {
          className: _styles.default.select,
          errorMsg: errorMsg,
          hasError: Boolean(errorMsg),
          id: field.name,
          placeholder: label,
          value: field.value,
          onBlur: function onBlur() {
            return form.setFieldTouched(field.name, true);
          },
          onChange: function onChange(value) {
            form.setFieldValue(field.name, value);
          }
        }));
      }
    }), R.map(function (_ref16) {
      var name = _ref16.name,
        label = _ref16.label,
        tooltip = _ref16.tooltip,
        valueTransformer = _ref16.valueTransformer;
      return /*#__PURE__*/_react.default.createElement(_formik.FastField, {
        name: "passports.".concat(index, ".").concat(name),
        render: function render(_ref17) {
          var field = _ref17.field,
            form = _ref17.form;
          var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
          return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
            tooltip: tooltip,
            className: (0, _classnames.default)(_styles.default['mw-140'], _styles.default.label),
            label: label
          }, /*#__PURE__*/_react.default.createElement(_Input.default, {
            className: _styles.default.select,
            errorMsg: errorMsg,
            hasError: Boolean(errorMsg),
            placeholder: label,
            value: field.value,
            onBlur: function onBlur() {
              return form.setFieldTouched(field.name, true);
            },
            onChange: function onChange(value) {
              form.setFieldValue(field.name, valueTransformer ? valueTransformer(value) : value);
            }
          }));
        }
      });
    }, externalPassportFieldsAsArray)));
  }, R.prop('passports', values)), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.moreInfo
  }, !disabledBookingPhoneControl && /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: "phone",
    render: function render(_ref18) {
      var _getPhoneControl$labe, _getPhoneControl;
      var field = _ref18.field,
        form = _ref18.form;
      var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
      return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
        className: (0, _classnames.default)(_styles.default.phone, _styles.default.label),
        id: field.name,
        label: (_getPhoneControl$labe = (_getPhoneControl = (0, _config.getPhoneControlInBoolingByOperatorForm)()) === null || _getPhoneControl === void 0 ? void 0 : _getPhoneControl.label) !== null && _getPhoneControl$labe !== void 0 ? _getPhoneControl$labe : t('CLIENT_NUMBER_CONTROL_LABEL')
      }, /*#__PURE__*/_react.default.createElement(_Input.default, {
        className: _styles.default.select,
        errorMsg: errorMsg,
        hasError: Boolean(errorMsg),
        id: field.name,
        placeholder: _constants.PHONE_PLACEHOLDER,
        value: field.value,
        onBlur: function onBlur() {
          return form.setFieldTouched(field.name, true);
        },
        onChange: function onChange(value) {
          form.setFieldValue(field.name, value);
        }
      }));
    }
  }), !disabledBookingPayerEmailControl && /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: "payerEmail",
    render: function render(_ref19) {
      var _getPayerEmailControl, _getPayerEmailControl2;
      var field = _ref19.field,
        form = _ref19.form;
      var label = (_getPayerEmailControl = (_getPayerEmailControl2 = (0, _config.getPayerEmailControlInBoolingByOperatorForm)()) === null || _getPayerEmailControl2 === void 0 ? void 0 : _getPayerEmailControl2.label) !== null && _getPayerEmailControl !== void 0 ? _getPayerEmailControl : t('PAYER_EMAIL_CONTROL_LABEL');
      var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
      return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
        className: (0, _classnames.default)(_styles.default.mail, _styles.default.label),
        id: field.name,
        label: label
      }, /*#__PURE__*/_react.default.createElement(_Input.default, {
        className: _styles.default.select,
        errorMsg: errorMsg,
        hasError: Boolean(errorMsg),
        id: field.name,
        placeholder: label,
        value: field.value,
        onBlur: function onBlur() {
          return form.setFieldTouched(field.name, true);
        },
        onChange: function onChange(value) {
          form.setFieldValue(field.name, value);
        }
      }));
    }
  }), onGetPreviousBookings && /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: "previousBookings",
    render: function render(_ref20) {
      var field = _ref20.field,
        form = _ref20.form;
      return /*#__PURE__*/_react.default.createElement(_PreviousBookingsControl.PreviousBookingsControl, {
        changedIDs: field.value,
        onChange: function onChange(prevBookingsIDs) {
          form.setFieldValue(field.name, prevBookingsIDs);
        },
        onHide: function onHide() {
          form.setFieldValue(field.name, []);
        }
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: "comment",
    render: function render(_ref21) {
      var _getCommentControl$la, _getCommentControl;
      var field = _ref21.field,
        form = _ref21.form;
      var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
      return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
        className: (0, _classnames.default)(_styles.default.comment, _styles.default.label),
        id: field.name,
        label: (_getCommentControl$la = (_getCommentControl = (0, _config.getCommentControlInBoolingByOperatorForm)()) === null || _getCommentControl === void 0 ? void 0 : _getCommentControl.label) !== null && _getCommentControl$la !== void 0 ? _getCommentControl$la : t('COMMENT_CONTROL_LABEL')
      }, /*#__PURE__*/_react.default.createElement(_Textarea.default, {
        className: _styles.default.select,
        errorMsg: errorMsg,
        hasError: Boolean(errorMsg),
        id: field.name,
        value: field.value,
        onChange: function onChange(value) {
          form.setFieldValue(field.name, value);
        }
      }));
    }
  }), R.length(bookingCompanies) > 1 && /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: "company",
    render: function render(_ref22) {
      var field = _ref22.field,
        form = _ref22.form;
      return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
        label: t('BOOKING_COMPANY_CONTROL_LABEL')
      }, /*#__PURE__*/_react.default.createElement(_Select.default, {
        className: _styles.default.select,
        items: bookingCompanies,
        value: field.value,
        onChange: function onChange(managerID) {
          form.setFieldValue(field.name, managerID);
        }
      }));
    }
  }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: "paymentType",
    render: function render(_ref23) {
      var field = _ref23.field,
        form = _ref23.form;
      var error = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
      return /*#__PURE__*/_react.default.createElement(_PaymentTypeControl.PaymentTypeControl, {
        id: field.name,
        error: error,
        value: field.value,
        onChange: function onChange(paymentType) {
          form.setFieldValue(field.name, paymentType);
        }
      });
    }
  }), !disabledBookingOperatorControl && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.services
  }, /*#__PURE__*/_react.default.createElement(_OperatorOptions.default, null)), /*#__PURE__*/_react.default.createElement(_BookingInfoOfReservation.BookingInfoOfReservation, {
    className: _styles.default.bookingAlert
  }), !disabledBookingConditionControl && /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: "isAcceptBookingConditions",
    render: function render(_ref24) {
      var field = _ref24.field,
        form = _ref24.form;
      var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _styles.default.checkboxWrapper
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        checked: field.value,
        errorMsg: errorMsg,
        hasError: Boolean(errorMsg),
        label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('ACCEPT_BOOKING_CONDITIONS_CONTROL_LABEL'), ' ', /*#__PURE__*/_react.default.createElement("a", {
          href: conditionsLink,
          rel: "noreferrer noopener",
          target: "_blank"
        }, t('ACCEPT_BOOKING_CONDITIONS_LINK', {
          operatorName: operatorName
        }))),
        labelTextClassName: _styles.default.checkboxLabel,
        onChange: function onChange(value) {
          form.setFieldValue(field.name, value);
        }
      }));
    }
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    disabled: isDisabledSubmitButton,
    loading: loading,
    theme: _Button.THEMES.PURPLE,
    onClick: !isDisabledSubmitButton ? submitForm : undefined
  }, t('BOOKING_BUTTON'))));
};
var enhancer = R.compose(_withProps.default, (0, _reactI18next.withTranslation)(['VALIDATION_ERRORS', 'SYMBOLS']), (0, _formik.withFormik)({
  mapPropsToValues: function mapPropsToValues(_ref25) {
    var options = _ref25.options,
      offer = _ref25.offer,
      initialPaymentType = _ref25.initialPaymentType,
      initialCompany = _ref25.initialCompany,
      externalPassportFields = _ref25.externalPassportFields,
      disabledPassportFields = _ref25.disabledPassportFields;
    var disabledBookingPayerEmailControl = (0, _config.isDisabledBookingPayerEmailControl)();
    var passport = R.mergeAll([R.omit(R.keys(disabledPassportFields), _constants.EMPTY_PASSPORT), R.map(R.prop('initialValue'), externalPassportFields)]);
    return _objectSpread({
      passports: R.concat(R.map(function () {
        return R.clone(passport);
      }, R.range(0, offer.people.adults)), R.map(function () {
        return (0, _helpers.createChildPassport)(passport);
      }, offer.people.children)),
      comment: '',
      phone: '',
      isAcceptBookingConditions: false,
      options: (0, _helpers.mapOptionsToValues)(options)
    }, disabledBookingPayerEmailControl ? {} : {
      payerEmail: ''
    }, {}, (0, _config.getOnGetPreviousBookings)() ? {
      previousBookings: []
    } : {}, {}, initialCompany ? {
      company: initialCompany
    } : {}, {}, initialPaymentType !== undefined ? {
      paymentType: initialPaymentType
    } : {});
  },
  validationSchema: function validationSchema(_ref26) {
    var t = _ref26.t,
      offer = _ref26.offer,
      options = _ref26.options,
      initialPaymentType = _ref26.initialPaymentType,
      disabledPassportFields = _ref26.disabledPassportFields,
      externalPassportFields = _ref26.externalPassportFields;
    var requiredFieldMessage = t('REQUIRED_FIELD');
    var invalidCharactersMessage = t('INVALID_CHARACTERS');
    var invalidDateMessage = t('INVALID_DATE');
    var invalidRange = t('INVALID_DATE_RANGE');
    var invalidEmail = t('NOT_CORRECT_EMAIL');
    var invalidFieldLength = t('INVALID_FIELD_LENGTH', {
      length: PASSPORT_VALIDATE_MIN_LENGTH,
      symbolWord: (0, _fn.declension)(PASSPORT_VALIDATE_MIN_LENGTH, [t('ONE_SYMBOL'), t('SOME_SYMBOLS'), t('MANY_SYMBOLS')])
    });
    return (0, _yup.object)(R.mergeAll([{
      passports: (0, _yup.array)().of((0, _yup.object)(_objectSpread({
        name: (0, _yup.string)().matches(/^[A-Za-z -]+$/, invalidCharactersMessage).required(requiredFieldMessage),
        surname: (0, _yup.string)().matches(/^[A-Za-z -]+$/, invalidCharactersMessage).required(requiredFieldMessage),
        passport: (0, _yup.string)().min(PASSPORT_VALIDATE_MIN_LENGTH, invalidFieldLength).matches(/^[A-Za-z0-9]+$/, invalidCharactersMessage).required(requiredFieldMessage),
        citizenship: (0, _yup.number)().required(requiredFieldMessage),
        birthday: (0, _yup.string)().required(requiredFieldMessage).test('birthday', invalidRange, R.partialRight(_helpers.birthdayValidator, [offer])).test('birthday', invalidDateMessage, _helpers.isDateBeforeToday).test('birthday', invalidDateMessage, _helpers.maxAgeValidator),
        passportExpireDate: (0, _yup.string)().required(requiredFieldMessage).test('passportExpireDate', invalidDateMessage, function (expireDate) {
          return (0, _helpers.getIsPassportExpireDateValidator)({
            expireDate: expireDate,
            startTourDate: offer.date,
            months: 3,
            nights: offer.nights
          });
        }),
        sex: (0, _yup.string)().required(requiredFieldMessage)
      }, !disabledPassportFields.passportGivenDate ? {
        passportGivenDate: (0, _yup.string)().required(requiredFieldMessage).test('passportGivenDate', invalidDateMessage, _helpers.isDateBeforeToday)
      } : {}, {}, (0, _helpers.createValidationsSchemaByExternalPassportFields)(externalPassportFields))))
    }, (0, _config.isDisabledBookingConditionControl)() ? undefined : {
      isAcceptBookingConditions: (0, _yup.bool)().oneOf([true], requiredFieldMessage)
    }, (0, _config.isDisabledBookingPhoneControl)() ? undefined : {
      phone: (0, _yup.string)().required(requiredFieldMessage).matches(_constants.PHONE_VALIDATION_MASK, t('INVALID_PHONE_NUMBER'))
    }, (0, _config.isDisabledBookingPayerEmailControl)() ? undefined : {
      payerEmail: R.call(R.when(function () {
        var _ref27 = (0, _config.getPayerEmailControlInBoolingByOperatorForm)() || {},
          isRequired = _ref27.isRequired;
        return typeof isRequired === 'function' && isRequired(offer);
      }, function (schema) {
        return schema.required(requiredFieldMessage);
      }), (0, _yup.string)().email(invalidEmail))
    }, R.isEmpty(options) ? undefined : {
      options: (0, _helpers.getOptionsSchema)(options)
    }, {
      comment: R.call(R.when(function () {
        var _ref28 = (0, _config.getCommentControlInBoolingByOperatorForm)() || {},
          isRequired = _ref28.isRequired;
        return typeof isRequired === 'function' && isRequired(offer);
      }, function (schema) {
        return schema.required(requiredFieldMessage);
      }), (0, _yup.string)())
    }, initialPaymentType !== undefined ? {
      paymentType: (0, _yup.number)().required(requiredFieldMessage)
    } : undefined]));
  },
  handleSubmit: function handleSubmit(values, _ref29) {
    var _ref29$props = _ref29.props,
      bookingOffer = _ref29$props.bookingOffer,
      queryID = _ref29$props.queryID;
    bookingOffer(values, queryID);
  }
}), _react.memo);
BookingFormByOperator.propTypes = {
  queryID: _propTypes.default.string.isRequired
};
var BookingForm = exports.BookingForm = enhancer(BookingFormByOperator);